import { OrgChart } from 'd3-org-chart'
import { useEffect, useRef } from 'react';
import styled from 'styled-components';

const ChartWrapper = styled.div`
    width: 100%;
    overflow: auto;
    padding: 24px;
    box-sizing: border-box;
    background-color: #FFFFFF;
    border-radius: 12px;
    box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.05);
`

const OrganogramaContainer = ({ dados }) => {

    const chartRef = useRef(null)
    const chartInstance = useRef(null)

    useEffect(() => {

        if (dados && dados.length > 0) {

            chartInstance.current = new OrgChart()
                .container(chartRef.current)
                .data(dados)
                .nodeHeight(() => 120)
                .nodeWidth(() => 320)
                .childrenMargin(() => 40)
                .compactMarginBetween(() => 15)
                .compactMarginPair(() => 80)
                .nodeContent((d) => `
                    <div style="
                      padding: 10px;
                      background: white;
                      border-radius: 8px;
                      box-shadow: 0 2px 6px rgba(0,0,0,0.15);
                      font-family: sans-serif;
                    ">
                      <div style="font-weight: bold; font-size: 16px;">${d.data.name}</div>
                      <div style="font-size: 14px; color: #555;">${d.data.title}</div>
                      <div style="font-size: 14px; color: #555;">${d.data.centro_custo}</div>
                      <div style="font-size: 14px; color: #555;">${d.data.contrato ? d.data.contrato : '-'}</div>
                    </div>
                `)
                .render();
        }

    }, [ dados ])

    return (
        <>
            <ChartWrapper>
                <div ref={ chartRef } />
            </ChartWrapper>
        </>
    )

}

export default OrganogramaContainer;